module.exports = __webpack_public_path__ + "static/media/diamonds_Q.24e43763.png";